import { render, staticRenderFns } from "./PoisView.vue?vue&type=template&id=457f5204&scoped=true&"
import script from "./PoisView.vue?vue&type=script&lang=js&"
export * from "./PoisView.vue?vue&type=script&lang=js&"
import style0 from "./PoisView.vue?vue&type=style&index=0&id=457f5204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f5204",
  null
  
)

export default component.exports